function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettingsTemplate = require('./settings.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SettingsOverlay = /*#__PURE__*/function () {
  function SettingsOverlay(app, mod) {
    _classCallCheck(this, SettingsOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false, true, false);
  }
  return _createClass(SettingsOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      this.overlay.showClosable(SettingsTemplate());
      var root = document.querySelector('.settings-overlay');
      if (!root) {
        return;
      }
      var movement = root.querySelector('[data-setting="mouseover_for_movement"]');
      var popups = root.querySelector('[data-setting="remove_card_popups"]');
      var combat_overlays = root.querySelector('[data-setting="use_combat_overlays"]');
      var visual_menu = root.querySelector('[data-setting="use_visual_menu"]');
      if (movement) {
        movement.checked = this.mod.movementMouseoverEnabled();
      }
      if (popups) {
        popups.checked = this.mod.cardPopupsRemoved();
      }
      if (combat_overlays) {
        combat_overlays.checked = this.mod.loss_overlay ? this.mod.loss_overlay.overlayEnabled() : true;
      }
      if (visual_menu) {
        visual_menu.checked = this.mod.visualMenuEnabled();
      }
      root.querySelectorAll('input[data-setting]').forEach(function (input) {
        input.onchange = function (e) {
          var setting = e.currentTarget.dataset.setting;
          if (setting === 'mouseover_for_movement') {
            _this.mod.saveGamePreference('pathsofglory_mouseover_for_movement', e.currentTarget.checked ? 1 : 0);
            if (!e.currentTarget.checked) {
              _this.mod.removeMovementCues();
            }
          }
          if (setting === 'remove_card_popups') {
            _this.mod.saveGamePreference('pathsofglory_remove_card_popups', e.currentTarget.checked ? 1 : 0);
            _this.mod.applyCardPopupPreference();
          }
          if (setting === 'use_combat_overlays' && _this.mod.loss_overlay) {
            _this.mod.loss_overlay.setOverlayEnabled(!!e.currentTarget.checked);
          }
          if (setting === 'use_visual_menu') {
            _this.mod.saveGamePreference('pathsofglory_use_visual_menu', e.currentTarget.checked ? 1 : 0);
            if (!e.currentTarget.checked && _this.mod.hud) {
              _this.mod.hud.hideVisualMenu();
            }
          }
        };
      });
    }
  }]);
}();
module.exports = SettingsOverlay;